<template>
  <DeepNavigationDrawer
    v-model="show"
    data-test-id="deepa-chat-drawer"
    disable-resize-watcher
    disable-route-watcher
    location="end"
    :max-width="800"
    :min-width="320"
    :permanent="!xs"
    :resizable="!smAndDown"
    :temporary="xs"
    touchless
    :width="drawerWidth"
  >
    <div class="d-flex flex-column h-100">
      <v-card-item class="flex-shrink-0 py-2">
        <template #prepend>
          <DeepAppIcon height="24" logo="deepa" width="24" />
        </template>
        <v-card-title class="text-body-large">
          {{ t('deepa_chat.title') }}
        </v-card-title>
        <v-card-subtitle v-if="title" data-test-id="deepa-chat-title">
          {{ title }}
        </v-card-subtitle>
        <template #append>
          <v-btn
            v-tooltip="{
              text: t('deepa_chat.new_chat_hint'),
              location: 'bottom',
              openDelay: 300,
            }"
            :aria-label="t('deepa_chat.new_chat')"
            density="comfortable"
            :disabled="!canStartNewChat"
            icon="far fa-plus"
            name="btn-deepa-chat-new"
            variant="text"
            @click="newChat()"
          />
          <v-btn
            v-tooltip="{
              text: t('deepa_chat.export.title'),
              location: 'bottom',
              openDelay: 300,
            }"
            :aria-label="t('deepa_chat.export.title')"
            density="comfortable"
            :disabled="!canExport"
            icon="far fa-floppy-disk"
            name="btn-deepa-chat-export"
            variant="text"
            @click="showExportDialog = true"
          />
          <v-btn
            :aria-label="t('dialogs.close')"
            density="comfortable"
            icon="far fa-xmark"
            name="btn-deepa-chat-close"
            variant="text"
            @click="close"
          />
        </template>
      </v-card-item>
      <DeepAChatContext class="flex-shrink-0" :nodes="contextNodes" />
      <v-divider />
      <DeepAChatView />
    </div>

    <DeepAChatExportDialog v-model="showExportDialog" />
  </DeepNavigationDrawer>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import DeepAChatContext from '@/pocs/chat/components/DeepAChatContext.vue'
import DeepAChatExportDialog from '@/pocs/chat/components/DeepAChatExportDialog.vue'
import DeepAChatView from '@/pocs/chat/components/DeepAChatView.vue'
import { useContextDeepAChat } from '@/pocs/chat/composables/ctx-deepa-chat'
import { DeepAppIcon, DeepNavigationDrawer } from '@deepcloud/deep-ui-lib'

const { t } = useI18n()
const { xs, smAndDown, width } = useDisplay()

const {
  show,
  contextNodes,
  messages,
  loading,
  title,
  canStartNewChat,
  newChat,
  close,
} = useContextDeepAChat()

const showExportDialog = ref(false)

const canExport = computed(
  () =>
    !loading.value &&
    messages.value.some(
      (message) => message.role === 'assistant' && !!message.content,
    ),
)

const drawerWidth = computed(() => (smAndDown.value ? width.value : 400))
</script>
